import { createAction } from "@reduxjs/toolkit";
import type { TeacherStudentDetails } from "@shared-kernel/application/ports/teacher/teacher-repository";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const teacherRetrieveStudent = createApiThunk<TeacherStudentDetails, string>(
  "teachers/teacherRetrieveStudent",
  async (email: string, { extra: { teacherRepository } }) => {
    return teacherRepository!.getStudentByEmail(email);
  },
);

export const resetTeacherStudentRetrieval = createAction("teachers/resetTeacherStudentRetrieval");
